<template>
  <div class="cityPartnerDetails">
    <van-sticky>
      <div
        class="cityPartnerDetailsNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">装饰合伙人</span>
        <img
          class="navRight"
          @click="goMore()"
          src="./../../../assets/decoration/more.png"
          alt=""
        />
      </div>
    </van-sticky>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="content">
        <div class="tip" v-if="cityPartnerPtatus.status_total == -3">
          <div>
            <div class="tipContent">
              <p ref="detailDom" :class="{ unfold: isUnfold }">
                您已被拉黑，请尽快联系工作人员处理。 拉黑原因：{{
                  cityPartnerPtatus.reason
                }}
              </p>
            </div>
            <div class="tipMore" v-if="showDetailBtn">
              <span v-if="!isUnfold" @click="isUnfold = true"
                >展开<img
                  src="./../../../assets/decoration/moreBottom.png"
                  alt=""
              /></span>
              <span v-if="isUnfold" @click="isUnfold = false"
                >关闭<img src="./../../../assets/decoration/moreTop.png" alt=""
              /></span>
            </div>
          </div>
        </div>
        <div class="tip" v-if="cityPartnerPtatus.status_total == -1">
          <p>合同已到期，请尽快联系工作人员处理。</p>
        </div>
        <div class="tip" v-if="cityPartnerPtatus.status_total == 2">
          <p>续费基础信息待审核。</p>
        </div>
        <div
          class="tip"
          v-if="
            cityPartnerPtatus.status_total == -4 ||
            cityPartnerPtatus.status_total == -5
          "
        >
          <p>
            续费信息被驳回：{{
              cityPartnerPtatus.pay_record
                ? cityPartnerPtatus.pay_record.remark
                : ""
            }}。
          </p>
        </div>
        <div class="tip" v-if="cityPartnerPtatus.status_total == 0">
          <p>合同待生效。</p>
        </div>
        <!-- 合伙人信息 -->
        <div class="user">
          <div>
            <h3 @click="show = true">
              {{ userData.province_and_city
              }}<img src="./../../../assets/decoration/cityBtm.png" />
            </h3>
            <p>Hi～{{ userData.partner ? userData.partner.nickname : "-" }}</p>
            <p>
              <span> 合同有效期至:{{ userData.ended_at }} </span>
              <img
                v-if="cityPartnerPtatus.status_total == -1"
                src="./../../../assets/decoration/expire.png"
                alt=""
              />
            </p>
          </div>
          <img
            v-if="cityPartnerNum == 1"
            src="./../../../assets/decoration/cityPartner1.png"
            alt=""
          />
          <img
            v-if="cityPartnerNum == 2"
            src="./../../../assets/decoration/cityPartner2.png"
            alt=""
          />
          <img
            v-if="cityPartnerNum == 3"
            src="./../../../assets/decoration/cityPartner3.png"
            alt=""
          />
          <img
            v-if="cityPartnerNum == 4"
            src="./../../../assets/decoration/cityPartner4.png"
            alt=""
          />
          <img
            v-if="cityPartnerNum == 0"
            src="./../../../assets/decoration/cityPartner5.png"
            alt=""
          />
        </div>
        <div class="detailsData">
          <!-- 提现信息 -->
          <div class="withdraw">
            <p>当前可提现：</p>
            <div class="mid">
              <h1>{{ userData.balance }}</h1>
              <img
                @click="toEmbody()"
                src="./../../../assets/decoration/right3.png"
                alt=""
              />
            </div>
            <div class="btmDet">
              <div class="item">
                <p>结算总计</p>
                <span>{{ userData.settled }}</span>
              </div>
              <div class="line"></div>
              <div class="item">
                <p>已提现</p>
                <span>{{ userData.withdrawn }}</span>
              </div>
              <div class="line"></div>
              <div class="item">
                <p>订单数</p>
                <span>{{ userData.order_count }}</span>
              </div>
            </div>
          </div>
          <!-- 分佣信息 -->
          <div class="fy">
            <CentCommission
              v-if="area_id"
              ref="centCommission"
              :is_agent="false"
              :area_id="area_id"
              :key="area_id"
              :minDate="new Date(userData.created_at)"
              :isiOSX="isiOSX"
            ></CentCommission>
          </div>
        </div>
      </div>
    </van-pull-refresh>

    <van-action-sheet v-model="show" :closeable="false" title="请选择一个城市">
      <div class="popContent">
        <div
          class="item"
          v-for="(item, index) in cityList"
          :key="index"
          @click="toSelectCity(item, index)"
        >
          <div>
            <img
              v-if="(index + 6) % 5 == 1"
              src="./../../../assets/decoration/citySelect1.png"
              alt=""
            />
            <img
              v-if="(index + 6) % 5 == 2"
              src="./../../../assets/decoration/citySelect2.png"
              alt=""
            />
            <img
              v-if="(index + 6) % 5 == 3"
              src="./../../../assets/decoration/citySelect3.png"
              alt=""
            />
            <img
              v-if="(index + 6) % 5 == 4"
              src="./../../../assets/decoration/citySelect4.png"
              alt=""
            />
            <img
              v-if="(index + 6) % 5 == 0"
              src="./../../../assets/decoration/citySelect5.png"
              alt=""
            />
            <span>{{ item.province_and_city }}</span>
          </div>
          <img
            src="./../../../assets/decoration/uncheckedY.png"
            v-if="!item.checked"
            alt=""
          />
          <img src="./../../../assets/decoration/checkedY.png" v-else alt="" />
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import CentCommission from "./../components/centCommission.vue";
export default {
  data() {
    return {
      isiOSX: false,
      area_id: null,
      userData: {},
      cityPartnerPtatus: {},
      show: false,
      cityList: [],
      type: null, //是否是城市选择进入 1是
      cityPartnerNum: 1,
      needRefresh: true,
      isLoading: false,
      detailDom: null,
      isUnfold: false,
      showDetailBtn: false,
    };
  },
  components: { CentCommission },
  created() {
    this.isiOSX = this.isIphoneX();
  },
  activated() {
    if (this.needRefresh) {
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      if (this.$route.query.area_id) {
        this.area_id = this.$route.query.area_id;
      }
      if (this.$route.query.type) {
        this.type = this.$route.query.type;
      }
      if (this.$route.query.cityPartnerNum) {
        this.cityPartnerNum = this.$route.query.cityPartnerNum;
      }
      this.getData();
      this.getCityPartnerPtatus();
      this.getCityData();
    } else {
      this.getData();
    }
    this.detailDom = this.$refs.detailDom;
    this.showDetailBtnFun();
    window.addEventListener("resize", this.showDetailBtnFun);
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/decoration/embody/embody") {
      this.needRefresh = false;
    } else {
      this.needRefresh = true;
    }
    next();
  },
  methods: {
    showDetailBtnFun() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.detailDom = this.$refs.detailDom;
          // console.log(this.detailDom);
          if (this.detailDom) {
            this.showDetailBtn =
              this.detailDom.clientHeight < this.detailDom.scrollHeight;
          }
        }, 100);
      });
    },
    goBack() {
      if (this.type == 1) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: "/decoration/index",
          query: {
            token: JSON.parse(sessionStorage.getItem("token")),
          },
        });
      }
    },
    // 下拉刷新
    onRefresh() {
      this.getData();
      this.getCityPartnerPtatus();
      this.$refs.centCommission.onRefresh();
    },
    // 获取城市合伙人区域详情
    getData() {
      this.$api
        .post("decoration/member/city/partner/show", {
          area_id: this.area_id,
        })
        .then((res) => {
          this.userData = res;
          this.userData.created_at = this.userData.created_at.replace(
            /-/g,
            "/"
          );
        });
    },
    // 获取城市合伙人区域状态
    getCityPartnerPtatus() {
      this.$api
        .post("decoration/member/city/partner/status/info", {
          area_id: this.area_id,
        })
        .then((res) => {
          this.isLoading = false;
          this.cityPartnerPtatus = res;
        });
    },
    // 获取城市列表
    getCityData() {
      this.$api.get("decoration/member/city/partner/area/list").then((res) => {
        this.cityList = res.area;
        this.cityList.forEach((item) => {
          if (item.id == this.area_id) {
            item.checked = true;
          }
        });
      });
    },
    // 选择城市
    toSelectCity(item, index) {
      this.cityList.forEach((item) => {
        item.checked = false;
      });
      item.checked = true;
      this.cityPartnerNum = (index + 6) % 5;
      this.area_id = item.id;
      this.show = false;
      this.getData();
      this.getCityPartnerPtatus();
    },
    goMore() {
      this.$router.push({
        path: "/decoration/cityPartner/more",
      });
    },
    // 体现
    toEmbody() {
      this.$router.push({
        path: "/decoration/embody/embody",
        query: {
          type: 2,
          city_agent_id: this.area_id,
        },
      });
    },
  },
};
</script>
<style lang="less">
.cityPartnerDetails {
  min-height: 100%;
  background: #f5f6ff;
  .cityPartnerDetailsNav {
    background: #f5f6ff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
    .navRight {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 16px;
      bottom: 10px;
    }
  }
  .content {
    .tip {
      display: flex;
      justify-content: space-between;
      padding: 10px 16px;
      background-color: #ffdbc6;
      align-items: center;
      color: #ff7e31;
      p {
        font-size: 14px;
        margin-right: 10px;
      }
      span {
        font-size: 12px;
        border-radius: 12px;
        border: 1px solid #ff7e31;
        height: 24px;
        line-height: 24px;
        width: 80px;
        text-align: center;
      }
      .tipContent {
        display: flex;
        justify-content: space-between;
        p {
          font-size: 14px;
          margin-right: 10px;
          // border: 1px solid red;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          white-space: normal;
          word-break: break-all;
          word-wrap: break-word;
          text-align: justify;
          line-height: 24px;
        }
        .unfold {
          -webkit-line-clamp: 99;
        }
        span {
          font-size: 12px;
          border-radius: 12px;
          border: 1px solid #ff7e31;
          height: 24px;
          line-height: 24px;
          min-width: 80px;
          text-align: center;
        }
      }
      .tipMore {
        display: flex;
        // justify-content: flex-end;
        span {
          font-size: 14px;
          display: flex;
          align-items: center;
          border: none;
          img {
            width: 12px;
            height: 12px;
          }
        }
      }
    }
    .user {
      margin: 0 24px;
      display: flex;
      justify-content: space-between;
      div {
        margin-bottom: 16px;
        h3 {
          font-size: 24px;
          font-weight: 700;
          color: #333333;
          margin: 25px 0 0;
          line-height: 33px;
          img {
            width: 14px;
            height: 14px;
            margin-left: 5px;
          }
        }
        p {
          font-size: 14px;
          color: #999999;
          display: flex;
          align-items: center;
          margin-top: 4px;
          height: 20px;
          line-height: 20px;
          img {
            width: 40px;
            height: 16px;
            align-self: center;
          }
        }
      }
      img {
        width: 80px;
        height: 80px;
        align-self: flex-end;
      }
    }
    .detailsData {
      .withdraw {
        margin: 0 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // border: 1px solid red;
        box-shadow: 0px 16px 48px 0px rgba(88, 83, 233, 0.5);
        height: 200px;
        border-radius: 16px;
        background-image: url("./../../../assets/decoration/earnings.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        p {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.7);
          line-height: 17px;
          margin-top: 32px;
          padding: 0 16px;
        }
        .mid {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 45px;
          // margin: 12px 16px 0;
          padding: 0 16px;
          h1 {
            margin: 0;
            font-size: 32px;
            color: #ffffff;
          }
          span {
            background-color: rgba(116, 45, 45, 0.1);
            border-radius: 16px;
            padding: 4px 14px;
            line-height: 18px;
          }
          img {
            width: 20px;
            height: 20px;
            padding: 20px;
          }
          .forbidden {
            color: rgba(255, 255, 255, 0.5);
          }
          .noForbidden {
            color: rgba(255, 255, 255, 1);
          }
        }
        .btmDet {
          height: 70px;
          border-radius: 0 0 16px 16px;
          background-color: rgba(255, 255, 255, 0.2);
          display: flex;
          justify-content: space-between;
          align-items: center;
          .item {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            p {
              margin: 0;
              font-size: 12px;
              line-height: 17px;
              color: rgba(255, 255, 255, 0.7);
            }
            span {
              font-size: 14px;
              font-weight: 700;
              color: #ffffff;
              line-height: 20px;
              margin-top: 6px;
            }
          }
          .line {
            width: 1px;
            height: 30px;
            background: #6661f0;
          }
        }
      }
      .fy {
        margin-top: 24px;
      }
    }
  }
  .popContent {
    margin: 12px 16px 42px;
    .item {
      margin-top: 12px;
      background: #f5f6ff;
      border-radius: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 32px 24px;
      div {
        display: flex;
        align-items: center;
        img {
          width: 48px;
          height: 48px;
        }
        span {
          margin-left: 12px;
          font-size: 16px;
          color: #333333;
        }
      }
      > img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>